import * as ISaticInter from './static-inter.i';

export class Ca implements ISaticInter.ICa {
  prixGlobal = 0;
  prixRessource = 0;

  constructor(source?: ISaticInter.ICa) {
    if (source) {
      Object.assign(this, { prixGlobal: source.prixGlobal, prixRessource: source.prixRessource });
    }
  }
}

export class DataApp implements ISaticInter.IDataApp {
  nbApp: 0;
  taux: 0;

  constructor(source?: ISaticInter.IDataApp) {
    if (source) {
      Object.assign(this, { nbApp: source.nbApp, taux: source.taux });
    }
  }
}
